export default __webpack_public_path__ + "static/media/game-btn.aa8033da.png";